import { render, staticRenderFns } from "./AppReferences.vue?vue&type=template&id=dcffe52a"
import script from "./AppReferences.vue?vue&type=script&lang=js"
export * from "./AppReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports